import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { AuthContext } from "../Auth";
// components
import Loader from "../components/Loader";
import { applyPaySaF } from "../services/Payments/SAF/applyPaySaF";
import { Error500, ErrorTransaction } from "../alerts/Error";

const Saf = () => {
  const { invoiceId } = useParams();
  const { userAuth, setShowLoginExpired } = useContext(AuthContext);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handlerLoaderShow = () => {
    Swal.close();
    setLoader(true);
  };

  const handlerLoaderHide = () => {
    setLoader(false);
  };

  // redirecciona a viewinvoice
  const redirectToErrorView = () => {
    window.location.replace(process.env.REACT_APP_CLIENTES_BASE_URL + `viewinvoice.php?id=${invoiceId}&errortransfer=true`);
  };

  useEffect(() => {
    const init = async () => {
      handlerLoaderShow();
      const dataSaF = await applyPaySaF({
        invoiceId,
        token: userAuth?.token,
        callbackError: () => {
          Error500(() => {
            handlerLoaderShow();
            redirectToErrorView();
          });
        },
      });

      // se recibio respuesta
      if (dataSaF) {
        // la respuesta es de error
        if (dataSaF.result === "error") {
          handlerLoaderHide();
          switch (dataSaF.error) {
            case "user": // al usuario con sesion no le pertenece el invoice
            case "add_funds": // tiene item de add funds
            case "status": // el estatus no es unpaid
            case "saldo": // no cuenta con el saldo suficiente
            case "paymentmethod": // el método de pago no es SAF
            case "totalinvoice": // se aplico crédito parcial
              ErrorTransaction(() => {
                handlerLoaderShow();
                redirectToErrorView();
              });
              break;
            case "session":
              setShowLoginExpired(true);
              break;

            default:
              Error500(() => {
                handlerLoaderShow();
                redirectToErrorView();
              });
              break;
          }
        }

        // la respuesta es correcta
        if (dataSaF.result === "success") {
          navigate("/checkout/confirm/" + invoiceId + '?compra=exitosa');
        }
      }
    };

    if (userAuth?.token) {
      init();
    } else {
      // si no existe sesión, se le obliga a iniciar sesión al cliente
      setShowLoginExpired(true);
    }

  }, [invoiceId, userAuth]);

  return <Loader open={loader} />;
};

export default Saf;
